import { useEffect } from "react";
import { openTimeTrack } from "@/hooks/use-timetrack";

/** Compatibility launcher for older workbench/project controls. */
export function TimeEntryPopup({ projectId, pulseId, open, onOpenChange }: {
  projectId: string;
  pulseId: number;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  mousePosition: { x: number; y: number };
}) {
  useEffect(() => {
    if (!open) return;
    openTimeTrack({ view: "manual", projectId, targetType: "pulse", targetId: pulseId });
    onOpenChange(false);
  }, [open, projectId, pulseId, onOpenChange]);
  return null;
}
